import React from "react";
import { t } from "ttag";

interface IProps {
    formTitle: string;
}

interface IState {}

// TODO(ssr, LEVEL 1 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 1/10 due to 29 LOC, simple presentational component with no state or lifecycle methods.
export class WriteReviewFormHeader extends React.PureComponent<IProps, IState> {
    render() {
        return (
            <div className="write-review-form__header">
                <h2 className="write-review-form__title">
                    {this.props.formTitle}
                </h2>
                <p className="write-review-form__sub-title">
                    (
                    <span className="write-review-form__sub-title--red">*</span>
                    ){" "}
                    <span className="write-review-form__sub-title--italic">
                        {t`indicates a required field`}
                    </span>
                </p>
            </div>
        );
    }
}
